import { imagesTimeActions } from '../actions'
import ValidateFormObject, { validates } from '../utils/ValidateFormObject'
const {
  FETCH_IMAGETIME,
  FETCHING_IMAGETIME,
  FETCH_IMAGETIME_ERROR,
  FETCH_IMAGESTIME,
  FETCH_IMAGESTIMEALL,
  FETCHING_IMAGESTIME,
  FETCH_IMAGESTIME_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_IMAGETIME,
  DELETE_IMAGETIME,
  ADD_IMAGETIME,
  EDIT_IMAGETIME,
  FORM_TOUCHED,
  NEW_FORM_IMAGETIME,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  IMAGETIME_FORM_ERROR,
  RESET_STATE
} = imagesTimeActions

const initialState = {
  loadingImageTime: false,
  loadingImagesTime: false,
  fetchImageTimeError: false,
  fetchImagesTimeError: false,
  imagesTime: [],
  order: {
    column: 'nome',
    direction: 1
  },
  imageTime: {
    nome: ''
  },
  imagesTimePagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  imageTimeFormErrors: {},
  imageTimeFormTouched: false,
  modalOpen: false
}

const imageTimeSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    },
    tempo: {
      required: true,
      func: validates.isNumber,
      errorMessage: 'Este campo deve conter apenas caracteres numéricos.'
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    },
    tempo: {
      required: true,
      func: validates.isNumber,
      errorMessage: 'Este campo deve conter apenas caracteres numéricos.'
    }
  }
}

const ImageTimeValidate = new ValidateFormObject(imageTimeSchema)

const imagesTime = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_IMAGETIME:
      formSchemaType = action.imageTime._id ? 'edit' : 'add'
      return {
        ...state,
        imageTime: action.imageTime,
        imageTimeFormErrors: ImageTimeValidate.validate({
          formObject: action.imageTime,
          formSchemaType
        })
      }
    case IMAGETIME_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.imageTime._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        imageTimeFormErrors: ImageTimeValidate.validate({
          formObject: state.imageTime,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_IMAGETIME:
      return {
        ...state,
        imageTime: { ...initialState.imageTime },
        imageTimeFormErrors: ImageTimeValidate.validate({}),
        imageTimeFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        imageTimeFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_IMAGETIME:
      formSchemaType = (action.imageTime || {})._id ? 'edit' : 'add'
      return {
        ...state,
        imageTime: action.imageTime,
        loadingImageTime: false,
        fetchImageTimeError: false,
        imageTimeFormTouched: false,
        imageTimeFormErrors: ImageTimeValidate.validate({
          formObject: action.imageTime,
          formSchemaType
        })
      }
    case FETCHING_IMAGETIME:
      return {
        ...state,
        loadingImageTime: true,
        fetchImageTimeError: false
      }
    case DELETE_IMAGETIME:
      return {
        ...state,
        loadingImagesTime: false,
        fetchImageTimeError: false,
        imagesTime: state.imagesTime.map(imageTime => {
          if (imageTime._id === (action.imageTime || {})._id) {
            return action.imageTime
          }
          return imageTime
        })
      }
    case FETCH_IMAGETIME_ERROR:
      return {
        ...state,
        loadingImagesTime: false,
        imageTime: { ...initialState.imageTime },
        fetchImageTimeError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        imagesTimePagination: {
          ...state.imagesTimePagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        imagesTimePagination: {
          ...state.imagesTimePagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_IMAGESTIME:
      return {
        ...state,
        loadingImagesTime: false,
        imagesTime: action.imagesTime,
        fetchImagesTimeError: false,
        order: action.order,
        imagesTimePagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case FETCH_IMAGESTIMEALL:
      return {
        ...state,
        imagesTime: action.imagesTime
      }
    case EDIT_IMAGETIME:
      return {
        ...state,
        imagesTime: state.imagesTime.map(imageTime => {
          if (imageTime._id === action.imageTime._id) {
            return action.imageTime
          }
          return imageTime
        }),
        loadingImagesTime: false,
        fetchImageTimeError: false,
        loadingImageTime: false,
        fetchImagesTimeError: false
      }
    case FETCHING_IMAGESTIME:
      return {
        ...state,
        loadingImagesTime: true,
        fetchImagesTimeError: false
      }
    case FETCH_IMAGESTIME_ERROR:
      return {
        ...state,
        loadingImagesTime: false,
        fetchImagesTimeError: action.error,
        loadingImageTime: false
      }
    case ADD_IMAGETIME:
      return {
        ...state,
        loadingImagesTime: false,
        fetchImagesTimeError: false,
        loadingImageTime: false,
        imagesTime: [...state.imagesTime, action.imageTime]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default imagesTime



// WEBPACK FOOTER //
// ./src/reducers/imagesTime.js